import { Component, OnDestroy, OnInit } from "@angular/core";
import { NbMenuItem, NbMenuService } from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { indexedDb } from "../../../@core/services/indexedDB.service";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Customer } from "../../../models/customer.model";
import { Product } from "../../../models/product.model";
import { CustomerService } from "../../../services/customer.service";
import { ProductService } from "../../../services/product.service";

@Component({
  selector: "ngx-footer",
  styleUrls: ["./footer.component.scss"],
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  uid = "";
  shopId = "";
  user?: User;
  loading = false;
  submitted = false;

  menuItems: NbMenuItem[] = [
    { title: "Mặt hàng", data: "products", icon: "cube-outline" },
    { title: "Khách hàng", data: "customers", icon: "people-outline" },
  ];

  constructor(
    private userService: UserService,
    private customerService: CustomerService,
    private productService: ProductService,
    private nbMenuService: NbMenuService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId;
        }
      });

    this.nbMenuService
      .onItemClick()
      .pipe(
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.data) {
          case "products":
            this.syncAllProducts();
            break;
          case "customers":
            this.syncAllCustomers();
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    console.log("FooterComponent/ngOnDestroy");
  }

  async syncAllProducts() {
    this.loading = true;
    this.submitted = true;
    const products = _.sortBy(this.productService.products, ["updatedOn"]);
    console.log("FooterComponent/syncAllProducts/products/length:", products);
    console.log(
      "FooterComponent/syncAllProducts/products/length/0:",
      products[0].updatedOn
    );
    console.log(
      "FooterComponent/syncAllProducts/products/length/length:",
      products[products.length - 1].updatedOn
    );

    const fromDate = moment(products[products.length - 1].updatedOn)
      .add(-1, "days")
      .toDate();
    console.log("FooterComponent/syncAllProducts/fromDate:", fromDate);

    this.productService
      .getProducts(this.shopId, fromDate)
      .then((querySnapshot) => {
        console.log(
          "FooterComponent/syncAllProducts/length:",
          querySnapshot.docs.length
        );

        let i = 0;
        if (querySnapshot.docs.length > 0) {
          querySnapshot.forEach(async (doc) => {
            let prod = new Product();
            prod = doc.data();
            prod.id = doc.id;
            prod.createdOn = convertTimestamp(doc.data().createdOn);
            prod.updatedOn = convertTimestamp(doc.data().updatedOn);

            //await indexedDb.products.put(prod, prod.id);
            this.productService.updateIndexedDb(prod);
            i++;
            if (i === querySnapshot.docs.length) {
              this.loading = false;
              this.submitted = false;
            }
          });
        } else {
          this.loading = false;
          this.submitted = false;
        }

        this.loading = false;
        this.submitted = false;
      })
      .catch((error) => {
        console.log("syncAllProducts/error:", error);
        this.loading = false;
        this.submitted = false;
      });
  }

  async syncAllCustomers() {
    this.loading = true;
    this.submitted = true;

    // const customers = _.sortBy(this.customerService.customers, ["timestamp"]);
    // const fromDate = moment(customers[customers.length - 1].updatedOn)
    //   .add(-1, "hours")
    //   .toDate();
    // console.log("FooterComponent/syncAllCustomers/fromDate:", fromDate);

    this.customerService
      .getCustomers(this.shopId)
      .then((querySnapshot) => {
        console.log(
          "FooterComponent/syncAllCustomers/length:",
          querySnapshot.docs.length
        );

        let i = 0;
        if (querySnapshot.docs.length > 0) {
          querySnapshot.forEach((doc) => {
            let cus = new Customer();
            cus = doc.data();
            cus.id = doc.id;
            cus.createdOn = convertTimestamp(doc.data().createdOn);
            cus.updatedOn = convertTimestamp(doc.data().updatedOn);

            this.customerService.updateIndexedDb(cus);

            i++;
            if (i === querySnapshot.docs.length) {
              this.loading = false;
              this.submitted = false;
            }
          });
        } else {
          this.loading = false;
          this.submitted = false;
        }
      })
      .catch((error) => {
        console.log("syncAllCustomers/error:", error);
        this.loading = false;
        this.submitted = false;
      });
  }
}
